import React, { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as action from '../../store/actions/profileActions';
import '../../assets/css/profile.css';
import '../../assets/css/img-upload.css';

const ProfilePicture = () => {
    const profileState = useSelector(state => state.profile.profile);
    const dispatch = useDispatch();
    
    const handleChange = (newValue) => {
        const reader = new FileReader();
        if (newValue.photoUrl) {
            reader.readAsDataURL(newValue.photoUrl);
            reader.onload = () => {
                var base64 = reader.result;
                var new64Value = {...newValue, photoUrl: base64};
                dispatch(action.collectProfileData({...profileState, 
                    profilePhotos: [...profileState.profilePhotos, new64Value]}));
            };
            reader.onerror = (error) => {
                console.error(error);
            }
        }
    }

    const renderImageViewer = () => {
        if (profileState.profilePhotos !== null) {
            if (profileState.profilePhotos.length === 2) {
                return (
                    <div className="uni-wrapper">
                        <input onChange={(e) => handleChange({ photoUrl: e.target.files[0], timeAdded: new Date().toISOString() })} type="file" name="file1" id="file1" className="inputfile" />
                        <label htmlFor="file1" className="input-label"><i className="fa fa-plus"></i></label>
                    </div>
                );
            }
            else if (profileState.profilePhotos.length === 1) {
                return (
                    <Fragment>
                        <div className="uni-wrapper">
                            <input onChange={(e) => handleChange({ photoUrl: e.target.files[0], timeAdded: new Date().toISOString() })} type="file" name="file1" id="file1" className="inputfile" />
                            <label htmlFor="file1" className="input-label"><i className="fa fa-plus"></i></label>
                        </div>

                        <div className="uni-wrapper">
                            <input onChange={(e) => handleChange({photoUrl: e.target.files[0], timeAdded: new Date().toISOString() })} type="file" name="file1" id="file2" className="inputfile" />
                            <label htmlFor="file2" className="input-label"><i className="fa fa-plus"></i></label>
                        </div>
                    </Fragment>
                );
            }
            else if(profileState.profilePhotos.length === 0){
                return (
                    <Fragment>
                        <div className="uni-wrapper">
                            <input onChange={(e) => handleChange({ photoUrl: e.target.files[0], timeAdded: new Date().toISOString() })} type="file" name="file1" id="file1" className="inputfile" />
                            <label htmlFor="file1" className="input-label"><i className="fa fa-plus"></i></label>
                        </div>

                        <div className="uni-wrapper">
                            <input onChange={(e) => handleChange({photoUrl: e.target.files[0], timeAdded: new Date().toISOString() })} type="file" name="file2" id="file2" className="inputfile" />
                            <label htmlFor="file2" className="input-label"><i className="fa fa-plus"></i></label>
                        </div>

                        <div className="uni-wrapper">
                            <input onChange={(e) => handleChange({photoUrl: e.target.files[0], timeAdded: new Date().toISOString() })} type="file" name="file3" id="file3" className="inputfile" />
                            <label htmlFor="file3" className="input-label"><i className="fa fa-plus"></i></label>
                        </div>
                    </Fragment>
                );
            }
        }
    }

    const renderSelectedImages = () => {
        if (profileState.profilePhotos !== null) {
            var existingPhotos = profileState.profilePhotos.map((photo,index) => {
                return <img key={index} src={photo.photoUrl} className="pic-upload-wrapper" />
            });
    
            return existingPhotos;
        }
        else {
            return null;
        }
    }

    return (
        <div className="uni-form">
            <div className="uni-img-upload-grp">
                {renderSelectedImages()}
                {renderImageViewer()}
            </div>
        </div>
    );
};

export default ProfilePicture;